import { Outlet } from 'react-router';
import { BottomNav } from '@/components/BottomNav';

import './Layout.css';

export function Layout() {
  return (
    <>
    <div className="sizeadjustment">
      <div className="scrollable">
        <Outlet />
      </div>
      <BottomNav />
    </div>
    </>
  );
}
